// Backward compatibility export - use CartPreviewModal for new implementations
export { CartPreviewModal as default } from './CartPreviewModal';
